export interface LegendItemProps {
  /** Color to display in the swatch */
  color: string;
  /** Label text to display */
  label: string;
  /** Optional additional className */
  className?: string;
}

/**
 * Legend item atom - displays a color swatch with accompanying label
 *
 * Used in timeline legends to indicate what each color/segment represents.
 */
export function LegendItem({ color, label, className = '' }: LegendItemProps) {
  return (
    <div
      className={`
        flex items-center gap-2
        ${className}
      `}
    >
      <div className="h-3 w-4 shrink-0 rounded-full" style={{ backgroundColor: color }} />
      <span className="text-text-muted">{label}</span>
    </div>
  );
}
